import { Component, Input, ViewEncapsulation, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { element } from 'protractor';

import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
//import { ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormGroupName} from '@angular/forms';
import { ValidationFormsService } from './validation-forms.service';
import { ValidatorFn, ValidationErrors } from '@angular/forms';
import { ToasterComponent, ToasterPosition } from '@coreui/angular';
import { AppToastComponent as ToastComp } from '../../../services/shared-service/toast-simple/toast.component'
import { HttpService } from '../../../services/http-service/http.service'
import { ModalDirective } from 'ngx-bootstrap/modal';

import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from '../../../services/storege-service/storage.service';
import * as moment from 'moment';
import { ToolService } from '../../../services/tool/tool.service';

@Component({
  //selector: 'app-toasters',
  templateUrl: 'basic-forms.component.html',
  styleUrls: ["../../../../../node_modules/ngx-bootstrap/datepicker/bs-datepicker.css",],
  //encapsulation: ViewEncapsulation.None,
  providers: [ ValidationFormsService, ]
})


export class BasicFormsComponent {


  minDate = new Date(2017, 5, 10);
  maxDate = new Date(2022, 9, 15);

  bsValue: Date = new Date();


  public isEnabled: boolean = true;


  public mfData? : object = {};
  public dbMatchResultsData?;
  public dbMatchResultsTeamAData? = Array();
  public dbMatchResultsTeamBData? = Array();
  public courts?;
  public invistigationActions?;
  public users?;
  isUpdate: boolean = false;
  dbFunction?: string;
  matchId: string;
  bookingId: string;
  bookingOffusId: string;
  invId: string;
  facilityName: string;
  courtName: string;
  matchType: string;
  matchNoOfSets: string;
  matchNotes: string;
  invDescription: string;
  invActionTaken: string;
  invNotes: string;
  matchStartTime: string;
  matchEndTime: string;
  invStatus: string;
  playerName: string;
  teamName: string;
  set1A: string;
  set2A: string;
  set3A: string;
  resultSet1A: string;
  resultSet2A: string;
  resultSet3A: string;
  resultSet1B: string;
  resultSet2B: string;
  resultSet3B: string;
  notes: string;
  invistigationAction: string;
  public facilityId = '';
  public isLoading = false;

  isError: boolean = false;

  simpleForm: FormGroup;
  submitted = false;
  formErrors: any;

  @ViewChild('invistigationCompleteModal', {static: false}) public invistigationCompleteModal: ModalDirective;
  @ViewChild('invistigationCloseModal', {static: false}) public invistigationCloseModal: ModalDirective;

  @ViewChild(ToastComp) toastComp: ToastComp;

  public paddingStyle: Object = { 'padding-right': '20px'};

  tableHeaders = ['Header 1', 'Header 2', 'Header 3'];
  tableRows = [
    ['Cell', 'Cell', 'Cell'],
    ['Cell', 'Cell', 'Cell'],
    ['Cell', 'Cell', 'Cell']
  ];

  constructor(
    private router: Router, 
    private http: HttpClient, 
    public route: ActivatedRoute,
    private fb: FormBuilder,
    public vf: ValidationFormsService, 
    public httpService: HttpService,
    private toastr: ToastrService,
    private localInterfaceSrv: LocalInterfaceService,
    private storageSrv: StorageService,
    public toolService: ToolService,
    ) {
    //if (localStorage.getItem('currentUser') === null) {this.router.navigateByUrl('/login');}
    if (localStorage.getItem('lang') === "ar") {
      //this.toasterconfig = new ToasterConfig({tapToDismiss: true, timeout: 5000, positionClass: 'toast-top-left'});
    }
    //this.toasterService = toasterService;
    this.formErrors = this.vf.errorMessages;
    this.facilityId = this.storageSrv.getFacilityId();

    if(this.router.getCurrentNavigation().extras.state?.createData == null)
    {
      this.isUpdate = true;
      this.mfData = this.router.getCurrentNavigation().extras.state?.data;
      this.matchId = this.mfData['matchId'];
      this.bookingId = this.mfData['bookingId'];
      this.bookingOffusId = this.mfData['bookingOffusId'];
      this.invId = this.mfData['invId'];
      this.facilityName = this.mfData['facilityName'];
      this.courtName = this.mfData['courtName'];
      this.matchType = this.mfData['matchType'];
      this.matchNoOfSets = this.mfData['matchNoOfSets'];
      this.matchNotes = this.mfData['matchNotes'];
      this.invDescription = this.mfData['invDescription'];
      this.invActionTaken = this.mfData['invActionTaken'];
      this.invNotes = this.mfData['invNotes'];
      this.matchStartTime = this.mfData['matchStartTime'];
      this.matchEndTime = this.mfData['matchEndTime'];
      this.invStatus = this.mfData['invStatus'];
      this.notes = this.mfData['notes'];
      this.invistigationAction = this.mfData['invistigationAction'];
    }
    else
    {
      this.matchId = '';
      this.bookingId = '';
      this.bookingOffusId = '';
      this.invId = '';
      this.facilityName = '';
      this.courtName = '';
      this.matchType = '';
      this.matchNoOfSets = '';
      this.matchNotes = '';
      this.invDescription = '';
      this.invActionTaken = '';
      this.invNotes = '';
      this.matchStartTime = '';
      this.matchEndTime = '';
      this.invStatus = '';
      this.notes = '';
      this.invistigationAction = '';
    }
    this.loadMatchResults();
    this.loadInvistigationActions();
    this.createForm();
  }

  isCollapsed: boolean = false;
  iconCollapse: string = 'icon-arrow-up';

  @Input() message : string;
  messages: string[] = [];
  updatedData = this.mfData;

  // Validators.pattern('^[0-9]{4}[\/][1-9]|1[012][\/][0-9]{2}$')]
  createForm() {
    this.simpleForm = this.fb.group({
      facilityName: [this.facilityName, [Validators.required]],
      courtName: [this.courtName, [Validators.required]],
      matchType: [this.matchType, [Validators.required]],
      matchNoOfSets: [this.matchNoOfSets, [Validators.required]],
      matchNotes: [this.matchNotes, [Validators.required]],
      invDescription: [this.invDescription, [Validators.required]],
      invActionTaken: [this.invActionTaken, [Validators.required]],
      invNotes: [this.invNotes, [Validators.required]],
      matchStartTime: [this.matchStartTime, [Validators.required]],
      matchEndTime: [this.matchEndTime, [Validators.required]],
      startDate: [this.matchStartTime, [Validators.required]],
      endDate: [this.matchEndTime, [Validators.required]],
      invStatus: [this.invStatus],
      playerName: [this.playerName],
      teamName: [this.teamName],
      invistigationAction: [this.invistigationAction],
      resultSet1A: [null],
      resultSet2A: [null],
      resultSet3A: [null],
      resultSet1B: [null],
      resultSet2B: [null],
      resultSet3B: [null],
      notes: [this.notes]
    }, { });
  }
  get f() { return this.simpleForm.controls; }


  async showSuccess(msg) {

    await this.toastr.success(msg, 'Success');

    if (this.isUpdate && !this.isError)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {

        });;
      });  
    }
    else if (!this.isUpdate && this.isError == false)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
        });;
      });  
    }
  }

  showError(msg) {
    //this.toasterService.pop('error', 'Error', msg);
  }

  public showPayment()
  {
    //this.router.navigate(['facility'], {state: {data: ''}, relativeTo: this.route});
    // if (this.editFlag == true)
    // {
    //   this.editFlag = false;
    // }
    // if (this.editFlag == false)
    // {
    //   this.editFlag = true;
    // }
    // this.myDivRef.nativeElement.scrollIntoView({behavior: "smooth", block: "start" });
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.simpleForm.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    return invalid;
}

completeCase()
{
  this.invistigationCompleteModal.show();
}
closeCase()
{
  this.invistigationCloseModal.show();
}


saveCase = () => {
  return new Promise<any>(async (resolve, reject) => {
    this.isLoading = true;
    let notes = this.f['notes'].value;
    
    const fields = {
      investigationId: this.invId,
      action: 'final',
      set1A: this.f['resultSet1A'].value,
      set2A: this.f['resultSet2A'].value,
      set3A: this.f['resultSet3A'].value,
      set1B: this.f['resultSet1B'].value,
      set2B: this.f['resultSet2B'].value,
      set3B: this.f['resultSet3B'].value,
      notes: notes
    };
    this.localInterfaceSrv.updateInvistigation(fields)
    .then(async res => {
      resolve(res);
      this.showSuccess('Invistigation Updated');
    })
    .catch(err => { 
      reject(err); 
      this.toastr.error(err.desc, "Error");
    })
    .finally(() => this.isLoading = false);
  });
}

closeDBCase = () => {
  return new Promise<any>(async (resolve, reject) => {
    this.isLoading = true;
    let notes = this.f['notes'].value;
    
    const fields = {
      investigationId: this.invId,
      action: 'close',
      notes: notes
    };
    this.localInterfaceSrv.updateInvistigation(fields)
    .then(async res => {
      resolve(res);
      this.showSuccess('Invistigation Updated');
    })
    .catch(err => { 
      reject(err); 
      this.toastr.error(err.desc, "Error");
    })
    .finally(() => this.isLoading = false);
  });
}

loadMatchResults = () => {
  return new Promise<any>(async (resolve, reject) => {
    this.isLoading = true;
    this.localInterfaceSrv.getMatchResults(this.matchId)
    .then(res => {
      this.dbMatchResultsData = Object.values(res);
      this.dbMatchResultsData[0].forEach(item => {
        if (item.playerTeam == 'Team A')
        {
          const newObj = item;
          this.dbMatchResultsTeamAData.push(newObj);
        }
        else
        {
          const newObj = item;
          this.dbMatchResultsTeamBData.push(newObj);
        }
      });
      this.isLoading = false;
      resolve(res);
    })
    .catch(err => { 
      reject(err); 
      this.toolService.showConsoleLog(err)
      //this.toastr.error(err.description, "Error");
    })
    .finally(() => this.isLoading = false);
  });
}

loadInvistigationActions = () => {
  return new Promise<any>(async (resolve, reject) => {
    this.isLoading = true;
    this.localInterfaceSrv.getInvistigationActions()
    .then(res => {
      this.invistigationActions = res;
      this.isLoading = false;
      resolve(res);
    })
    .catch(err => { 
      reject(err); 
      this.toolService.showConsoleLog(err)
      //this.toastr.error(err.description, "Error");
    })
    .finally(() => this.isLoading = false);
  });
}

  openCall(phoneNumber) {
    window.open('tel:' + phoneNumber, '_self');
  }

  openWhatsapp(phoneNumber): void {
    window.open("https://wa.me/" + phoneNumber, "_blank");
  }

  markAsLiar = (playerId, matchId, status) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      const fields = {
        playerId: playerId,
        matchId: matchId,
        status: status
      };
      this.localInterfaceSrv.updateMatchResultStatus(fields)
      .then(async res => {
        resolve(res);
        this.toastr.success("Status Updated", "Success");
        //this.dangerModal.hide();
        this.route.queryParams.subscribe(async params => {
          await this.loadMatchResults();
      });
        //window.location.reload()
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.desc, "Error");
        //this.dangerModal.hide();
      })
      .finally(() => this.isLoading = false);
    });
  }

  async delay(ms: number) {
    //await new Promise(resolve => setTimeout(()=>resolve(), ms)).then(()=>this.toolService.showConsoleLog("fired"));
  }

  collapsed(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  updateData(name: string): void {
    this.updateData['nameEn'] = name;
  }
 

  expanded(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.iconCollapse = this.isCollapsed ? 'icon-arrow-down' : 'icon-arrow-up';
  }
}
